import { Button } from "react-bootstrap";
import './taskplan.css'

const MoodRegulation = ({
  options = [],
  selected,
  onChange,
  isDisabled
}) => {
  return (
    <div className="mood-slider-wrapper">

      {/* FIXED BACKGROUND LINE */}
      <div className="mood-track-line" />

      <div className="mood-options">
        {options.map((option) => {
          const isActive = selected === option.key;

          return (
            <div
              key={option.key}
              className="mood-option"
              onClick={() => {
                if (!isDisabled) {
                  onChange(option.key)
                }
              }
              }
            >
              <div
                className={`mood-circle ${isActive ? "active" : ""
                  }`}
              />
              <span className="mood-label">
                {option?.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MoodRegulation;
